// Load jQuery from NPM
import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import 'bootstrap';
import 'lodash';
import bsCustomFileInput from 'bs-custom-file-input';

(function(){
	'use strict';

	// Global variables
	var squiz = {
		'fn': {},
		'vars': {
			'animSpeed' : 400,
			'navIsAnimating' : false,
		}
	};

	squiz.utils = {
        /*
        * Debounce function
        * https://davidwalsh.name/javascript-debounce-function
        */
       'debounce': function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this,
                    args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },
        'getQueryVariable': function(variable) {

            var query = window.location.search.substring(1);
            var vars = query.split("&");
            
            for (var i=0;i<vars.length;i++) {
                
                var pair = vars[i].split("=");
                
                if (pair[0] == variable) {
                    return pair[1];
                }
            }

            return(false);

        },
        'isDevelopment': function() {
            return process && process.env && (process.env.NODE_ENV === 'development');
        },
        
        /**
         * Cookie functions - get|set|delete
         * as per https://www.w3schools.com/js/js_cookies.asp
         * @param - (str) 'cookie name', (str) 'cookie value', (int) expiry in days [optional]
         */
        'getCookie': function(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        },
        'setCookie': function(cname, cvalue, exdays) {
            
            var expires;

            if (exdays) {
                var d = new Date();
                d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
                expires = 'expires=' + d.toUTCString();
            } else {
                expires = "";
            }
            
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },
        'deleteCookie': function deleteCookie(name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }

    };

	/**
	* ===================================================
	* Responsive helpers
	* ===================================================
	*/
	var ww = $(window).width();

	var breakpoint = {
		'lg': 1200,
		'md': 992,
		'sm': 768,
		'xs': 544
	};

	$('.main table').each(function() {
		var $table = $(this);
		$table.wrap('<div class="table-responsive-sm table-responsive-md table-responsive-lg"></div>');
	});



	/**
	* ===================================================
	* Helpers
	* ===================================================
	*/
	squiz.fn.smpScrollTopBtn = function(selector, offset){

		$(selector).click(function(){

			$('html,body').animate({
				scrollTop: offset
			}, squiz.vars.animSpeed);

			return false;

		});
	}

	squiz.fn.smpClearNavItemState = function(subElementContainer, subElementBtns){

		if(!$('.smp-header__mobile-btn').is(':visible')){
			$(subElementContainer).removeClass('active').attr('aria-expanded','false');
			$(subElementBtns).find('button').removeClass('active');
		}
	}

	squiz.fn.smpToggleBtn = function(selector){

		if(!$(selector).hasClass('active')){
			$(selector).addClass('active');
			return false;
		} else {
			$(selector).removeClass('active');
			return true;
		}

	}

	squiz.fn.smpAnimMenu = function(selector, open){

		if(!open){

			$(selector).slideDown(squiz.vars.animSpeed, function(){
				$(selector).addClass('active');
			});

		} else {

			$(selector).slideUp(squiz.vars.animSpeed, function(){
				$(selector).removeClass('active');
			});
		}
	}

	squiz.fn.smpToggleSubMenu = function(selector, show){

		if(show){
			$(selector).addClass('active');
			$(selector).attr('aria-expanded','true');
		} else {
			$(selector).removeClass('active');
			$(selector).attr('aria-expanded','false');
		}

	}

	// Make squiz variable available to the console for debugging

	window.squiz = squiz;
}());
